import { render, staticRenderFns } from "./vehicleTempOkRate.vue?vue&type=template&id=01236a08&scoped=true"
import script from "./vehicleTempOkRate.vue?vue&type=script&lang=js"
export * from "./vehicleTempOkRate.vue?vue&type=script&lang=js"
import style0 from "./vehicleTempOkRate.vue?vue&type=style&index=0&id=01236a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01236a08",
  null
  
)

export default component.exports